// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useTransferInstructions } from '../transferInstruction/useTransferInstructions';
import useExecutedTransfers from './useExecutedTransfers';
import useRejectedTransfers from './useRejectedTransfers';

export const useGetTransferQueries = () => {
  // instructions
  const transferInstructions = useTransferInstructions();
  const rejectedTransfers = useRejectedTransfers();
  const executedTransfers = useExecutedTransfers();

  return {
    transferInstructions,
    rejectedTransfers,
    executedTransfers,
  };
};
